import React from "react";

import { useProfile, useQueryString } from "app/context";
import { Icon, Badge } from "@culturehq/components";
import { useExpand } from "app/hooks";
import { t, Trans } from "app/utils";
import { queryKey } from "components/filters/InterestFilter";

const Interests = ({ onInterestClicked }) => {
  const { profile } = useProfile();
  const { onToggleQueryStringValue } = useQueryString();
  const { interests } = profile;
  const [expanded, onExpand] = useExpand();
  const MAX_NUMBER_TO_SHOW = 10;

  const handleOnInterestClicked = interest => {
    if (onInterestClicked) {
      onToggleQueryStringValue(queryKey, interest.id);
      onInterestClicked(interest);
    }
  };

  const handleClick = isExpanded => {
    onExpand(isExpanded);
  };

  return (
    <div className="Interests hidden-lg">
      <div className="Interests__title">
        <h2><Trans>MY INTERESTS</Trans></h2>
        <a aria-label={t("View all user interests")} href="/profile/settings/interests"><Icon icon="ios-gear" className="category-icon" /></a>
      </div>
      <div className="chq-ffd-tags">
        {expanded
          ? (
            <>
              {interests.map(interest => (
                <Badge key={interest.id} onClick={() => handleOnInterestClicked(interest)} aria-label={`Select ${t(interest.name)} as filter`}>
                  <Icon icon="heart-ol" />
                  {interest.name}
                </Badge>
              ))}
              <div key="minus-option" className="Interests__minus-option">
                <span onClick={() => handleClick(false)}>
                  <Icon icon="minus" />
                  {" "}
                  show less
                </span>
              </div>
            </>
          ) : (
            <>
              {interests.map((interest, index) => (
                (index < MAX_NUMBER_TO_SHOW) && (
                  <Badge key={interest.id} onClick={() => handleOnInterestClicked(interest)} aria-label={`Select ${t(interest.name)} as filter`}>
                    <Icon icon="heart-ol" />
                    {interest.name}
                  </Badge>
                )
              ))}
              {interests.length > 10 && (
                <div key="plus-option" className="Interests__plus-option">
                  <span onClick={() => handleClick(true)}>
                    <Icon icon="plus" />
                    {" "}
                    {interests.length - MAX_NUMBER_TO_SHOW}
                  </span>
                </div>
              )}
            </>
          )}
      </div>
    </div>
  );
};

export default Interests;
